import React from "react";
import Modal from "../../components/ui/Modal";
import FormMoreInfo from "../../components/FormMoreInfo/FormMoreInfo";

const ModalMoreInfo = ({
  modalBusinessInfo,
  setModalBusinessInfo,
  submitBusiness,
  businessAddress,
  title,
  submitLabel,
}) => {
  const handleSubmit = async (data) => {
    await submitBusiness(businessAddress, data);
  };

  return (
    <Modal
      title={title}
      visible={modalBusinessInfo}
      onClose={() => setModalBusinessInfo(false)}
    >
      <FormMoreInfo onSubmit={handleSubmit} submitLabel={submitLabel} />
    </Modal>
  );
};

export default ModalMoreInfo;
